$(function() {
    // 会員登録の会員種別が保護者の時だけ注意書きを非表示
    // メールアドレスのpattern属性を調整
    if($('.js-signup-form').length) {
        function signUpValidate() {
            $('input[name="member_type_id"]:checked').each(function () {
                let memberType = $(this).val();
                let form  = $(this).closest('.js-signup-form');
                if(memberType == 5) {
                    // パターンを削除（attrでの書き換えではリセットされないため、removeAttrを使用）
                    form.find('.email-input').removeAttr('pattern');
                    // 注意書きを非表示に
                    form.find('.js-signup-attention').fadeOut("fast");
                }else{
                    // パターンを設定
                    form.find('.email-input').attr('pattern','^.+@[^@]+\.[^.]+\.ac\.jp|^.+@[^@]+\.[^.]+\.ct\.jp|^.+@[^@]+\.[^.]+\.nct\.jp|^.+@[^@]+\.[^.]+\.go\.jp$');
                    // 注意書きを表示
                    form.find('.js-signup-attention').fadeIn("fast");
                }
            });
        }
        // ページ読み込み時
        signUpValidate();

        // 会員種別を変更したとき
        $('input[name="member_type_id"]').on('change',function() {
            signUpValidate();
        });
    }
});
